<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sV6BUG/tc-custom/9781590207949.jpg?1728259310893" alt="This image is the cover for the book Almost a Crime"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Almost a Crime
      </h1>
      <p class="bookDescription body article font2">
        <b>This suspenseful tale of a glamorous marriage, a reckless affair, and a vengeful obsession is “deliciously readable” (<i>Daily Mail</i>).</b><br/><br/>Tom and Octavia Fleming glitter among the chattering classes of London in the late 1990s. Tom, a brilliant political strategist, and Octavia, an equally talented charity consultant, appear to have it all—good looks, money, success, and three pretty children—everything but precious time together. The truth is Tom is having an affair—and when Octavia realizes it, she plots her revenge against her husband. But nothing prepares Octavia for the identity of Tom’s mistress, and her misdemeanors hardly compare to the revenge enacted by the other woman after Tom calls it off . . . <br/><br/>Described by Dominick Dunne as a writer “with verve and heart, immersing the reader in a world of engrossing and unforgettable glamour and passion,” and praised by Barbara Taylor Bradford as “marvelously engrossing,” Penny Vincenzi presents a novel packed with twists, trysts, and thrills.<br/><br/>“Exposes the cracks in a British ‘power marriage’ and charts the frightening evolution of a spurned woman’s love into a dangerous obsession . . . [A] deft, swift contemporary epic.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Penny Vincenzi
      </h2>
      
      <p class="authorDescription body article">Penny Vincenzi has written seventeen bestselling novels, including No Angel, Something Dangerous, Into Temptation, Wicked Pleasures, Another Woman, Forbidden Places, Windfall, An Outrageous Affair, The Dilemma, Almost a Crime, and A Perfect Heritage. Before becoming a novelist, she worked at such magazines as Vogue, Tatler, and Cosmopolitan. She has four daughters, and divides her time between London and Gower, South Wales. Over seven million copies of her books have been sold worldwide.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      PENGUIN group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e46a214